import moment from "moment";

export function shortDate(date: string | Date | null | undefined, format?: string) {
  if (date) {
    date = moment(date).format(format || dateFormatDiplay);
  }
  return date;
}

export const currentdate = () => {
  return moment().format("DD/MM/yyyy");
};

export const dateFormatInputReference = "yyyy-MM-DD";
export const dateFormatDiplay = "DD/MM/YYYY";